const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/branded_apps_builder_ui.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { settingsHomeRoutes } from "@circle-react/lib/routes/settingsHome";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { checkIsBrandedAppsBuilderUIEnabled } from "@/react/hooks/useBrandedAppsFeatureFlags";

// Read by `useInitialData` in the builder: `page` is "onboarding", "hometabs"
// or a page id; `actionView` is "design" or "navigation".
interface BuilderSearch {
  actionView?: string;
  page?: string;
}
export const Route = createFileRoute("/_protected/_settingsLayout/settings/branded_apps_builder_ui")({
  validateSearch: (search: Record<string, unknown>): BuilderSearch => ({
    actionView: typeof search.actionView === "string" ? search.actionView : undefined,
    page: typeof search.page === "string" ? search.page : undefined
  }),
  beforeLoad: ({
    context
  }) => {
    const currentCommunity = context.punditUserContext?.currentCommunity;
    const isEnabled = checkIsBrandedAppsBuilderUIEnabled(currentCommunity);
    if (!isEnabled) {
      redirect({
        to: settingsHomeRoutes.index(),
        throw: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});